import React from 'react'
import loadingStyles from '../../../main-view.module.css'
import styles from '../../pages.module.css'

export const getLazyLoadingDummyPage = () => {
    return (
        <div className={styles['content-wrapper']}>
            <div>
                <div className={styles['page-description']}>
                    <div className={loadingStyles['load-stripe-full']} style={{ marginBottom: 5 + 'px' }}>
                        LOADINGTEXT
                    </div>
                    <div className={loadingStyles['load-stripe-long']}>LOADINGTEXT</div>
                </div>
                <div className={loadingStyles['load-stripes-container']}>
                    <div className={loadingStyles['load-stripes-box-1']}>
                        <div className={loadingStyles['load-stripe-long']}>LOADINGTEXT</div>
                    </div>
                    <div className={loadingStyles['load-stripes-box-2']}>
                        <div className={loadingStyles['load-stripe-long']}>LOADINGTEXT</div>
                    </div>
                </div>
                <div className={loadingStyles['load-stripes-container']}>
                    <div className={loadingStyles['load-stripes-box-1']}>
                        <div className={loadingStyles['load-stripe-long']}>LOADINGTEXT</div>
                    </div>
                    <div className={loadingStyles['load-stripes-box-2']}>
                        <div className={loadingStyles['load-stripe-long']}>LOADINGTEXT</div>
                    </div>
                </div>
            </div>
        </div>
    )
}
